import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import { SvgCalendar, SvgFilterDelete } from "../svg";
import Select from '../select'
import makeAnimated from "react-select/animated";
import SubscriptionsService from "../../api/subscriptions";


const translations = [
    gettext('Choose'),
    gettext('True'),
    gettext('False'),
]


export const PillChoiceFilter = (props) => {
    return (
        <div className="filter-choice">
            {props.filterType.choices.map(choice =>
                <button key={`${props.name}_${choice.value}`} onClick={() => props.changeFilterValue(props.name, choice.value)} type="button" className={`btn btn-sm btn-pill btn${props.filterValue === choice.value ? '' : '-outline'}-primary`}>{choice.label}</button>
            )}
        </div>
    )
}

export const PillMultiChoiceFilter = (props) => {
    const { filterValue } = props;
    const selected = filterValue ? filterValue.split(',') : [];
    const clickHandler = (clickedValue) => {
        if (selected.includes(`${clickedValue}`)) {
            selected.splice(selected.indexOf(`${clickedValue}`), 1)
        } else {
            selected.push(`${clickedValue}`)
        }
        props.changeFilterValue(props.name, selected.join(","))
    }
    return (
        <div className="filter-choice">
            {props.filterType.choices.map(choice =>
                <button key={`${props.name}_${choice.value}`} onClick={() => clickHandler(choice.value)} type="button" className={`btn btn-sm btn-pill btn${selected.includes(`${choice.value}`) ? '' : '-outline'}-primary`}>{choice.label}</button>
            )}
        </div>
    )
}

export const SelectorWithPillsFilter = (props) => {
    const { filterValue, filterType } = props;
    const selected = filterValue ? filterValue.split(',').map(id => parseInt(id)) : [];
    const clickHandler = (clickedValue) => {
        if (selected.includes(clickedValue)) {
            selected.splice(selected.indexOf(clickedValue), 1)
        } else {
            selected.push(clickedValue)
        }
        props.changeFilterValue(props.name, selected.join(","))
    }
    return (
        <>
            <div className="filter-select min-width-116">
                <select className="form-select" value="" onChange={(e) => clickHandler(parseInt(e.target.value))}>
                    <option key="default" value="">{gettext('Choose')}</option>
                    {filterType.choices.map(choice => {
                        if (!selected.includes(choice.value)) {
                            return <option key={`${props.name}_${choice.value}`} value={choice.value}>{choice.label}</option>
                        }
                    }
                    )}
                </select>
            </div>
            {selected.length > 0 &&
            <div className="filter-choice mt-4">
                {filterType.choices.map(choice => {
                    if (selected.includes(choice.value)) {
                        return (
                            <button key={`${props.name}_${choice.value}`} type="button" className={`btn btn-sm btn-pill btn-primary btn-icon-right`}>
                                {choice.label} 
                                <span className="ms-2" onClick={() => clickHandler(choice.value)}>
                                    <SvgFilterDelete />
                                </span>
                            </button>)
                    }
                }
                )}
            </div>
            }
        </>
    )
}


export const AsyncSelectorWithPillsFilter = (props) => {
    const { filterValue, filterType, loadOptions } = props;
    const [selectableOptions, setSelectableOptions] = useState([]);
    const [selected, setSelected] = useState(filterValue ? filterValue.split(',').map(id => parseInt(id)) : []);
    const selectInputRef = useRef();

    useEffect(() => {
        if(filterValue){
            new Promise(resolve =>
                resolve(SubscriptionsService.getSubscriptions([{'ids': filterValue}]))
            ).then(response => {
                let selected_values = response.results.map(subscription => {
                    return { label: `${subscription.customer.name} - ${subscription.plan.name} (${subscription.amount} ${subscription.currency})`, value: subscription.id }
                })
                setSelectableOptions(selected_values)
            })
        }
    }, [])
    
    const clickHandler = (selectedOption) => {
        let clickedValue = Object.assign({}, selectedOption);
        if (selected.includes(clickedValue.value)) {
            let selected_without = selected.toSpliced(selected.indexOf(clickedValue.value), 1)
            setSelected(selected_without)
        } else {
            setSelectableOptions([clickedValue].concat(selectableOptions))
            setSelected([clickedValue.value].concat(selected))
        }
    }
    const [query, setQuery] = useState("");
    const [options, setOptions] = useState([]);

    useEffect(() => {
        props.changeFilterValue(props.name, selected.join(","))
    }, [selected])

    useEffect(() => {
        if (query.length > 0) {
            loadOptions(query).then(response => {
                setOptions(response)
            })
        }
    }, [query])

    const handleChange = (selectedOption) => {
        if(selectedOption){
            clickHandler(selectedOption);
            selectInputRef.current.clearValue();
        }
    }
    
    return (
        <>
            <div className="filter-select min-width-116">
            <Select
                ref={selectInputRef}
                onChange={handleChange}
                options={options}
                onInputChange={(value) => setQuery(value)}
            />
            </div>
            {selected.length > 0 &&
            <div className="filter-choice mt-4">
                {selected.map(choice => {
                    if(selectableOptions.find(option => option.value === choice)){
                        return (
                            <button key={`${props.name}_${choice}`} type="button" className={`btn btn-sm btn-pill btn-primary btn-icon-right`}>
                                {selectableOptions.find(option => option.value === choice).label} 
                                <span className="ms-2" onClick={() => clickHandler(selectableOptions.find(option => option.value === choice))}>
                                    <SvgFilterDelete />
                                </span>
                            </button>)
                    }
                })}
            </div>
            }
        </>
    )
}

export const SelectFilter = (props) => {
    return (
        <div className="filter-select min-width-116">
            <select className="form-select" onChange={(e) => props.changeFilterValue(props.name, e.target.value)}>
                <option key="default" value="">{gettext('Choose')}</option>
                {props.filterType.choices.map(choice =>
                    <option key={`${props.name}_${choice.value}`} value={choice.value}>{choice.label}</option>
                )}
            </select>
        </div>
    )
}

export const BooleanChoiceFilter = (props) => {
    return (
        <div className="filter-select min-width-116">
            <select className="form-select" onChange={(e) => props.changeFilterValue(props.name, e.target.value)}>
                <option key="default" value="">{gettext('Choose')}</option>
                <option key={`${props.name}_true`} value={"true"}>{gettext('True')}</option>
                <option key={`${props.name}_false`} value={"false"}>{gettext('False')}</option>
            </select>
        </div>
    )
}

export const DateRangeFilter = (props) => {
    const [dateRange, setDateRange] = useState([Date.now(), Date.now()]);
    const [startDate, endDate] = dateRange;
    return (
        <div className="filter-daterange calendar min-width-116">
            <SvgCalendar />
            <DatePicker
                showIcon={false}
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                locale="is-IS"
                onChange={(update) => {
                    setDateRange(update);
                    props.changeFilterValue(props.name, update)
                }}
                monthsShown={2}
            />
        </div>
    )
}

export const ComparisonInputFilter = (props) => {
    return (
        <div className="filter-daterange">
            <select className={form - select}>
                <option value="lt">&lt;</option>
                <option value="lte">&lt;=</option>
                <option value="=">==</option>
                <option value="gte">&gt;=</option>
                <option value="gt">&gt;</option>
            </select>
            <input />
        </div>
    )
}

export const ComparisonSelectFilter = (props) => {
    return (
        <div className="filter-daterange">
            <select className={form - select}>
                <option value="lt">&lt;</option>
                <option value="lte">&lt;=</option>
                <option value="=">==</option>
                <option value="gte">&gt;=</option>
                <option value="gt">&gt;</option>
            </select>
            <select className={form - select}>
                {props.filterType.choices.map(choice =>
                    <option key={`${props.name}_${choice.value}`} value={choice.value}>{choice.label}</option>
                )}
            </select>
        </div>
    )
}